.grid {
  width: 100%;
}

.gridSizer {
  width: var(--small-screen-card-size);
}

.gutterSizer {
  width: var(--small-screen-gutter-size);
}

.item {
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
  width: var(--small-screen-card-size);
  margin-bottom: var(--small-screen-gutter-size);
  overflow: visible;
}

.item > img {
  width: 100%;
}

.cardBottom {
  height: 72px;
  padding: 0px 12px 0px 12px;
}

.cardBottomRow {
  display: flex;
  align-items: center;
  position: relative;
}

.popout {
  position: absolute;
  width: 300px;
  /* we need to set bottom so all popouts are starting from the same position */
  bottom: 0px;
  z-index: 10;
  border: solid 1px #e4e4e4;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
}

.designTitle {
  color: var(--color-easil-black);
  margin-bottom: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.caretWrapper {
  display: flex;
}

.caretOuterWrapFullFill {
  flex: 0.25 0 auto;
}

.image {
  border-radius: 2px 2px 0px 0px;
}

.popoutContentTop {
  border-bottom: 1px solid lightgray;
  padding: 16px;
}

.popoutContentTop1Row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 11px;
}

.popoutContentTop1Row > div:first-child {
  padding-right: 10px;
  font-size: 15px;
  color: var(--color-easil-black);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.popoutContentTop1RowEditting {
  align-items: center;
  display: flex;
  margin-bottom: 8px;
}

.popoutContentTop1RowEditting > svg:last-child {
  margin-left: 12px;
}

.editDesignName {
  height: 36px;
  margin-right: 16px;
}

.popoutContentTop > div + div {
  font-size: 13px;
  color: var(--color-easil-gray);
  margin-bottom: 0px;
}

.popoutContentMiddle {
  border-bottom: 1px solid lightgray;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 16px 0px 16px 0px;
}

.popoutContentMiddle > ul > li {
  display: flex;
  align-items: center;
  line-height: 1.71;
  color: var(--color-easil-gray-x-dark);
  margin-bottom: 10px;
  padding: 0px 16px 0px 16px;
  cursor: pointer;
}

.popoutContentMiddle > ul > li:last-child {
  margin-bottom: 0px;
}

.popoutContentMiddle > ul > li:hover {
  background-color: var(--color-hover-color);
}

.popoutContentMiddle > ul > li > div {
  padding-left: 12px;
}

.popoutContentBottom {
  border-bottom: 1px solid lightgray;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 16px;
}

.more {
  text-align: center;
  cursor: pointer;
  border: 1px solid lightgray;
  padding: 9px;
  border-radius: 4px;
}

.topRowLeftItem {
  margin-left: 32px;
}

@media screen and (min-width: 900px) {
  /* 5 columns for larger screens */
  .gridSizer {
    width: var(--large-screen-card-size);
  }

  .gutterSizer {
    width: var(--large-screen-gutter-size);
  }

  .item {
    width: var(--large-screen-card-size);
    margin-bottom: var(--large-screen-gutter-size);
  }
}
